

import React from "react";

const BadgeSuryaLogo: React.FC = () => {
    return (
        <svg width="73" height="22" viewBox="0 0 73 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="73" height="22" fill="#F2F2F3"/>
            <path fill="#333132" d="M20.1,15.56c-1.41,0-2.61-.64-3.06-1.62l-.02-.05.68-.61.05.1c.38.84,1.29,1.34,2.41,1.34,1.19,0,1.96-.83,1.96-1.85,0-.77-.48-1.25-1.5-1.5l-1.11-.26c-1.39-.32-2.1-1.06-2.1-2.26,0-1.48,1.21-2.41,2.88-2.41,1.25,0,2.34.58,2.78,1.49l.03.05-.69.61-.04-.1c-.34-.76-1.13-1.21-2.1-1.21-1.12,0-1.88.53-1.88,1.53,0,.81.46,1.26,1.46,1.48l1.12.25c1.37.3,2.12,1.12,2.12,2.3,0,1.5-1.23,2.72-2.99,2.72h0Z"/>
            <path fill="#333132" d="M28.46,15.56c-2.04,0-3.25-1.24-3.25-3.32v-5.68h.96v5.7c0,1.55.83,2.45,2.29,2.45s2.29-.91,2.29-2.45v-5.7h.96v5.68c0,2.05-1.25,3.32-3.25,3.32Z"/>
            <path fill="#333132" d="M40.14,15.44h-1.04l-.02-.03c-.26-.32-.37-.77-.37-1.42v-.82c0-1.27-.44-1.69-1.75-1.69h-1.82v3.97h-.96V6.56h2.29c2.9,0,3.5,1.29,3.5,2.38s-.64,1.85-1.82,2.12c1.09.19,1.54.8,1.54,2.02v.87c0,.58.12,1.02.37,1.37l.09.12h0ZM35.13,10.7h1.3c1.7,0,2.53-.55,2.53-1.68s-.83-1.67-2.53-1.67h-1.3v3.35Z"/>
            <path fill="#333132" d="M45.39,15.44h-.98v-3.46l-3-5.43h1.07l2.44,4.55,2.45-4.55h1.03l-3,5.43v3.46h0Z"/>
            <polygon fill="#333132" points="52.66 6.56 51.73 6.56 48.41 15.44 49.41 15.44 52.18 7.79 54.94 15.44 55.98 15.44 52.66 6.56"/>
            <rect fill="#333132" x="49.83" y="12.11" width="4.82" height=".83"/>
        </svg>
    );
};

export default React.memo(BadgeSuryaLogo);

